import {Component, OnInit} from '@angular/core';

@Component({
    selector: 'app-nft-add',
    templateUrl: './nft-add.component.html',
    styleUrls: ['./nft-add.component.css'],
    standalone: false
})
export class NftAddComponent implements OnInit {

  collection = {
    title: '',
    description: '',
    thumbnail: '',
    entity: ''
  };

  isCollectionCreated = false;
  isError = false;
  errMessage = '';
  categoryList = [];

  constructor() {
  }

  ngOnInit(): void {
  }

  categoryChange(value: string): void {

  }

  createCollection(): void {

  }
}
